import React from 'react';
import { useBrand } from '../contexts/BrandContext';

/**
 * شعار "مشهد" — يعرض الشعار المخصص من إعدادات الهوية البصرية إن وجد
 * ويطبّق نسبة التكبير/التصغير المحفوظة
 * 
 * @param {'dark'|'light'} variant
 * @param {'xs'|'sm'|'md'|'lg'|'xl'} size
 * @param {string} className
 * @param {'header'|'footer'} logoType
 */
const MashhadLogo = ({ variant = 'dark', size = 'md', className = '', logoType = 'header' }) => {
  let brand = { headerLogoUrl: null, footerLogoUrl: null, headerLogoScale: 100, footerLogoScale: 100, colors: null };

  try {
    brand = useBrand();
  } catch {
    // BrandContext غير متاح
  }

  const customLogoUrl = logoType === 'footer' ? brand.footerLogoUrl : brand.headerLogoUrl;
  const scale = logoType === 'footer' ? (brand.footerLogoScale || 100) : (brand.headerLogoScale || 100);
  const scaleRatio = scale / 100;

  // أبعاد مرنة (max) حسب الحجم
  const sizeConfig = {
    xs: { maxH: 32, maxW: 120 },
    sm: { maxH: 40, maxW: 160 },
    md: { maxH: 48, maxW: 200 },
    lg: { maxH: 60, maxW: 260 },
    xl: { maxH: 76, maxW: 320 },
  };

  const s = sizeConfig[size] || sizeConfig.md;

  // شعار مخصص من الهوية البصرية → صورة مع نسبة الأبعاد + scale
  if (customLogoUrl) {
    return (
      <img
        src={customLogoUrl}
        alt="شعار الموقع"
        style={{
          maxHeight: s.maxH * scaleRatio,
          maxWidth: s.maxW * scaleRatio,
          height: 'auto',
          width: 'auto',
        }}
        className={`object-contain flex-shrink-0 ${className}`}
      />
    );
  }

  // عند عدم رفع شعار من لوحة التحكم: عرض نص بسيط بألوان الهوية البصرية (لا شعار قديم ثابت)
  const textColor = variant === 'light' ? '#FFFFFF' : 'var(--color-foreground, #0f172a)';
  return (
    <span
      className={`font-black tracking-tight flex-shrink-0 ${className}`}
      style={{
        color: textColor,
        fontSize: size === 'xs' ? '1rem' : size === 'sm' ? '1.25rem' : size === 'md' ? '1.5rem' : size === 'lg' ? '1.75rem' : '2rem',
        fontFamily: "'IBM Plex Sans Arabic', 'Tajawal', sans-serif",
        maxHeight: (sizeConfig[size]?.maxH || 48) * scaleRatio,
      }}
      role="img"
      aria-label="شعار الموقع"
    >
      مشهد
    </span>
  );
};

export default MashhadLogo;
